import axios from "axios";
import { PolicyFormValues } from "../schemas/policy.types";
import { routes } from "../../General";
import React from "react";
import { Alert } from "../../../interface/alert.interface";

export const policyExcelService = async (
    values: PolicyFormValues,
    alertRef?: React.MutableRefObject<Alert | undefined>,
    overwrite = false
) => {
    const healthDisasterUploadURL = routes.api + "/health-disaster/excel-upload";

    const vigencias = values.vigenciaSelect ?? [];

    if (!values.file || !values.cdCliente || !values.poliza || vigencias.length === 0) {
        return;
    }

    const uploadResponse = await Promise.all(
        vigencias.map(async idQuotation => {
            const formData = new FormData();
            formData.append("file", values.file!);

            const selectedValidity = values.validityDetails?.find(v => v.idQuotation === idQuotation);

            const clientData = {
                cdCliente: values.cdCliente,
                typePolicy: values.tipoPol,
                policy: values.poliza,
                dateFrom: selectedValidity?.dateFrom ?? "",
                dateUntil: selectedValidity?.dateUntil ?? "",
                idManager: values.cdEjecutivo,
                idQuotation,
                idInsuranceCompany: values.cdAseguradora,
                overwrite,
            };

            formData.append("clientData", new Blob([JSON.stringify(clientData)], { type: "application/json" }));

            try {
                const response = await axios.post(healthDisasterUploadURL, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                return response.data;
            } catch (error) {
                alertRef?.current?.handle_error(error);
                return null;
            }
        })
    );

    return uploadResponse.find(r => r !== null);
};

export const getPolicyInformation = async (
    idClient: number,
    policy: string,
    idQuotation: number,
    idInsuranceCompany: number,
    alertRef?: React.MutableRefObject<Alert | undefined>
) => {
    const existingPoliciesURL = routes.api + "/health-disaster/existing-policies";

    const client = {
        cdCliente: idClient,
        policy: policy,
        idQuotation: idQuotation,
        idInsuranceCompany: idInsuranceCompany,
    };

    try {
        const response = await axios.post(existingPoliciesURL, client);

        return response.data;
    } catch (error) {
        alertRef?.current?.handle_error(error);
    }
};
